import { usePostHogFeatureFlag } from '@/hooks/usePostHogFeatureFlag';

/**
 * PostHog flag `lice-report-daily` gates the Weekly/Daily toggle on lice report pages.
 * Target internal users via PostHog release conditions (e.g. is OptoScale admin).
 */
export function useDailyLiceReportFeatureEnabled(): boolean {
    const { enabled } = usePostHogFeatureFlag('lice-report-daily');

    return enabled;
}
